import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { LocalizationProvider } from "@mui/lab";
import { Stack, TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import React, { useEffect, useState } from "react";
import cup from "../../../assets/images/page 1.png";
import "./PostContentMaking.css";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import Multiselect from "multiselect-react-dropdown";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import moment from "moment";

const PostContentMaking = () => {
  const { slug } = useParams();
  const [file, setFile] = useState("");
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [filePdf, setFilePdf] = useState("");
  const [videoFile, setVideoFile] = useState("");

  const [event, setEvent] = useState({});
  const [judges, setJudges] = useState([]);
  const [convertedContent, setConvertedContent] = useState(null);
  const [errorList, setErrorList] = useState([]);

  const [instruction, setInstruction] = useState({});

  const history = useHistory();

  useEffect(() => {
    axios.get(`/api/audition-event/for-post-content-making/${slug}`).then((res) => {
      if (res.data.status === 200) {
        let judges_array = [];
        setEvent(res.data.event);

        res.data.event.assigned_judges.forEach((judge, index) => {
          let user = judge?.user;
          judges_array.push({
            name: user.first_name + " " + user.last_name,
            id: user.id,
          });
        });
        setJudges(judges_array);
      }
    });
  }, [slug]);

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
    setVideoFile(URL.createObjectURL(file[0]));
  };

  const handlePdfChange = (file) => {
    setFilePdf(file[0]);
  };

  const [value, setValue] = React.useState(new Date());

  const [items, setItems] = useState([]);

  const handleSelect = (selectedList) => {
    setItems(selectedList);
  };

  const handleRemove = (selectedList) => {
    setItems(selectedList);
  };

  const submitPostMakingContent = (e) => {
    e.preventDefault();
    const fData = new FormData();
    fData.append("audition_id", event.id);
    if (items.length > 0) {
      items.forEach((item) => {
        fData.append("star_ids[]", Number(item.id));
      });
    }
    fData.append("instruction", convertedContent);
    fData.append("video", fileVideo);
    fData.append("image", imageData);
    fData.append("pdf", filePdf);
    fData.append("submission_date", moment(value).format("YYYY-MM-DD"));

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/promo-instruction/store`, fData)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            history.goBack();
          } else {
            setErrorList(res.data.validation_errors);
          }
        });
    });
  };

  return (
    <div className="liveMeetupBorder">
      <div className="d-flex px-4">
        <div className="faTrophy p-2">
          <img src={cup} alt="" className="mt-1" width="30px" />{" "}
          <span className="text-waning p-2 fw-bolder">
            Content Making Requirements for Star
          </span>
        </div>
      </div>
      <div className="my-2">
        <form
          onSubmit={submitPostMakingContent}
          id="input_form"
          encType="multipart/form-data"
        >
          <div className="row ms-5">
            <div className="form-group row mt-3">
              <label
                for="staticEmail"
                className="col-sm-2 col-form-label text-light "
              >
                Post Title
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control Frombtns"
                  value={event.title}
                  readOnly
                />
              </div>
            </div>

            <div className="form-group row mt-3">
              <label
                for="inputPassword"
                className="col-sm-2 col-form-label text-light "
              >
                Description
              </label>
              <div className="col-sm-8">
                <CKEditor
                  editor={ClassicEditor}
                  data={convertedContent}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setConvertedContent(data);
                  }}
                />
                <span className="text-danger">{errorList.instruction}</span>
              </div>
            </div>

            <div className="form-group row mt-3">
              <label
                for="staticEmail"
                className="col-sm-2 col-form-label text-light "
              >
                Select Superstar
              </label>
              <div className="col-sm-8">
                <Multiselect
                  options={judges}
                  selectedValues={items}
                  onSelect={handleSelect}
                  onRemove={handleRemove}
                  displayValue="name"
                />
              </div>
            </div>

            <div className="form-group row mt-3">
              <label
                for="staticEmail"
                className="col-sm-3 col-form-label text-light "
              >
                Upload Video Instruction For Star
              </label>

              <div className="col-sm-7 mb-2">
                <div className="row my-4">
                  <div className="col-md-10">
                    {videoFile ? (
                      <>
                        <ReactPlayer
                          url={videoFile}
                          // width="100%"
                          controls={true}
                          height="35vh"
                        />
                      </>
                    ) : (
                      <></>
                    )}
                    <input
                      type="file"
                      name="file"
                      id="setFile"
                      className="inputfile w-25"
                      accept="video/mp4"
                      onChange={(e) => handleVideoChange(e.target.files)}
                    />

                    <label for="setFile">
                      <i className="fas fa-cloud-upload-alt"></i> Upload Video
                    </label>
                    <span className="text-danger">{errorList.video}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group row mt-3">
              <label
                for="staticEmail"
                className="col-sm-3 col-form-label text-light "
              >
                Upload Video Instruction For Stat
              </label>

              <div className="col-sm-7 mb-2">
                <div className="row my-4">
                  {file ? (
                    <img
                      src={file}
                      alt="..."
                      className="demo-preview-image img-fluid"
                    />
                  ) : (
                    ""
                  )}
                  <div className="col-md-10">
                    <input
                      type="file"
                      name="imageFile"
                      id="imageFile"
                      className="inputfile w-25"
                      accept="image/jpg,image/jpeg, image/png"
                      onChange={(e) => handleImageChange(e.target.files)}
                    />

                    <label for="imageFile">
                      <i className="fas fa-cloud-upload-alt"></i> Upload Image
                    </label>
                    <span className="text-danger">{errorList.image}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group row mt-3">
              <label
                for="staticEmail"
                className="col-sm-3 col-form-label text-light "
              >
                Instruction pdf for the post
              </label>

              <div className="col-sm-7 mb-2">
                <div className="row d-flex justify-content-end my-4">
                  <div className="col-md-2 text-white">
                    {/* <img
                      src={file}
                      className="img-fluid avatar-img-src"
                      alt=""
                    /> */}
                  </div>
                  <div className="col-md-3 inputeParent">
                    <input
                      type="file"
                      name="pdfFile"
                      id="pdfFile"
                      accept=".pdf"
                      className="inputfile w-25"
                      onChange={(e) => handlePdfChange(e.target.files)}
                    />
                    <label for="pdfFile">
                      <i className="fa-solid fa-file-pdf"></i> 1 MB Maximum
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group row mt-3">
              <label
                for="staticEmail"
                className="col-sm-3 col-form-label text-light "
              >
                Content Submission Date
              </label>

              <div className="col-sm-7 row d-flex justify-content-end mb-2">
                <div className="col-md-3 dateParentPicker timeLengthPicker">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack spacing={3}>
                      <DatePicker
                        disablePast
                        label="Responsive"
                        openTo="day"
                        views={["year", "month", "day"]}
                        value={value}
                        onChange={(newValue) => {
                          setValue(newValue);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Stack>
                  </LocalizationProvider>
                  <span className="text-danger">
                    {errorList.submission_date}
                  </span>
                </div>
              </div>
            </div>

            <div className="row justify-content-end my-4">
              <div className="col-md-3 text-left">
                <button className="btn btn-warning px-4 fw-bold" type="submit">
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PostContentMaking;
